import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ReviewCard } from "@/components/ReviewCard";
import { Star } from "lucide-react";

export default function ReviewsPreview() {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    api.get("/reviews").then((r) => setReviews(r.data.slice(0, 3))).catch(() => {});
  }, []);

  return (
    <section
      id="reviews"
      data-testid="reviews-preview-section"
      className="relative py-24 sm:py-28"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <header className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <span className="font-script text-2xl text-[#b85b7e]">happy clients</span>
            <h2 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl text-[#3F2A56] mt-2 leading-tight">
              Tail wags &amp; thank-yous.
            </h2>
            <p className="mt-5 text-[#5C4A73] text-lg leading-relaxed">
              Honest words from the families and pets I&rsquo;ve had the joy of caring for.
            </p>
          </div>
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-1">
              {Array.from({ length: 5 }).map((_, i) => (
                <Star key={i} className="w-5 h-5 fill-[#D4AF37] text-[#D4AF37]" />
              ))}
            </div>
            <Link
              to="/reviews"
              data-testid="reviews-all-cta"
              className="rounded-full border-2 border-[#3F2A56] text-[#3F2A56] font-semibold px-6 py-3 hover:bg-[#3F2A56]/5 transition-colors"
            >
              Read all &amp; share yours
            </Link>
          </div>
        </header>

        <div className="grid md:grid-cols-3 gap-7">
          {reviews.map((r, idx) => (
            <ReviewCard key={r.id} review={r} rotation={idx % 2 === 0 ? -1 : 1.2} />
          ))}
        </div>
      </div>
    </section>
  );
}
